export default "__VITE_ASSET__CCnDuzvt__"